/* eslint-disable import/no-named-as-default */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Route, NavLink, Switch } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faStar,
  faUserCircle,
  faUsers,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";
import AboutCompany from "./AboutCompany";
import Reviews from "./Reviews";
import ApplicantReviews from "./ApplicantReviews";
import Team from "./Team";
import {
  Wrapper,
  RouterNav,
  RouterList,
  RouterItem,
  TabIcon,
  TabText,
} from "./styles/tabs-styles";

export const Tabs = ({
  teamMembersCount,
  toggleAboutCompanyModal,
  companyName,
  companyId,
}) => (
  <Wrapper className="animated delay-8 fadeIn">
    <RouterNav id="tab-nav">
      <RouterList>
        <RouterItem>
          <NavLink to="/reviews" id="reviews-link">
            <TabIcon>
              <FontAwesomeIcon icon={faStar} />
            </TabIcon>
            <TabText>Employer Reviews</TabText>
          </NavLink>
        </RouterItem>
        <RouterItem>
          <NavLink to="/applicant-reviews" id="applicant-reviews">
            <TabIcon>
              <FontAwesomeIcon icon={faUserCircle} />
            </TabIcon>
            <TabText>Candidate Reviews</TabText>
          </NavLink>
        </RouterItem>
        <RouterItem>
          <NavLink to="/about-company">
            <TabIcon>
              <FontAwesomeIcon icon={faInfoCircle} />
            </TabIcon>
            <TabText>About Company</TabText>
          </NavLink>
        </RouterItem>
        {teamMembersCount > 0 && (
          <RouterItem>
            <NavLink to="/team">
              <TabIcon>
                <FontAwesomeIcon icon={faUsers} />
              </TabIcon>
              <TabText>Team Members</TabText>
            </NavLink>
          </RouterItem>
        )}
      </RouterList>
    </RouterNav>
    <Switch>
      <Route exact path="/" component={Reviews} />
      <Route exact path="/reviews" component={Reviews} />
      <Route exact path="/applicant-reviews" component={ApplicantReviews} />
      <Route
        exact
        path="/about-company"
        render={() => (
          <AboutCompany toggleAboutCompanyModal={toggleAboutCompanyModal} />
        )}
      />
      <Route
        exact
        path="/team"
        render={() => <Team companyName={companyName} companyId={companyId} />}
      />
    </Switch>
  </Wrapper>
);

Tabs.propTypes = {
  teamMembersCount: PropTypes.number.isRequired,
  toggleAboutCompanyModal: PropTypes.func.isRequired,
  companyName: PropTypes.string.isRequired,
  companyId: PropTypes.number.isRequired,
};

const mapStateToProps = (state) => ({
  teamMembersCount: state.agencyProfile.profileData.teamMembers.length,
});

export default connect(mapStateToProps, {})(Tabs);
